import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import routerGuards from './RouterGuards';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/pasta-externa',
    name: 'pasta-externa',
    component: () => import('../views/pasta-externa/PastaExternaPage.vue'),
    meta: {
      isPrivate: false
    }
  },
  {
    path: '/sem-acesso',
    name: 'page-sem-acesso',
    component: () => import('@/views/error/PageSemAcesso.vue')
  },
  {
    path: '/sigilo',
    name: 'page-sigilo',
    component: () => import('@/views/error/PageSigilo.vue')
  },
  {
    path: '/resposta-comunique-se-tjsp',
    name: 'resposta-comunique-se-tjsp',
    component: () => import('@/views/resposta-comunique-se-tjsp/RespostaComuniqueseTjspPage.vue'),
    props: (route) => ({
      idTarefa: route.query.idTarefa,
      deEmailUsuario: route.query.deEmailUsuario
    }),

  },
  {
    path: '/401',
    name: 'page-401',
    component: () => import('@/views/error/Page401.vue')
  },
  {
    path: '/404',
    name: 'page-404',
    component: () => import('@/views/error/Page404.vue')
  },
  {
    path: '*',
    redirect: { name: 'page-404' }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(routerGuards.beforeEach);

export default router;
